import { useRegisterSW } from 'virtual:pwa-register/react'
export function PWAUpdate() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()
  if (!needRefresh) return null
  return (
    <div className="pwa-update" role="status">
      <strong>Доступна новая версия</strong>
      <p>Сохраните открытые формы перед обновлением.</p>
      <button className="button primary" onClick={() => void updateServiceWorker(true)}>
        Обновить приложение
      </button>
      <button className="button secondary" onClick={() => setNeedRefresh(false)}>
        Позже
      </button>
    </div>
  )
}
